import { Link } from "react-router-dom";
import '../styles/NewsStyles/News.css';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppChat from "../components/WhatsAppChat";
import NewsCard from "../components/NewsSection/NewsCard";
import NewsComingSoon from "../components/NewsSection/NewsComingSoon";
import UpcomingEvents from "../components/NewsSection/UpcomingEvents";
import { hasLivePosts, listPosts, SHOW_UNPUBLISHED } from "../news/posts";
import { usePageMeta } from "../hooks/usePageMeta";

const News = () => {
    usePageMeta(
        "News | Kole Medical",
        "News and updates from Kole Medical on medical devices, SAHPRA licensing and upcoming webinars.",
    );
    const posts = listPosts();
    // Until the first article is live, a "coming soon" card holds its place
    const comingSoon = !hasLivePosts();

    return (
        <div>
            <Navbar />
            <header className="km-pageHeader nw-pageHeader">
                <div className="km-container km-enter">
                    <p className="km-eyebrow">News</p>
                    <h1>News and updates</h1>
                    <p className="km-lead">
                        Updates from Kole Medical on medical devices, SAHPRA licensing and our upcoming webinars.
                    </p>
                    <nav className="nw-jump" aria-label="On this page">
                        <Link className="km-btn km-btn--accent" to={{ hash: "#articles" }}>Articles and news</Link>
                        <Link className="km-btn km-btn--outlineLight" to={{ hash: "#events" }}>Upcoming events</Link>
                    </nav>
                </div>
            </header>

            {/* ── ARTICLES AND NEWS ── */}
            <section className="km-section" id="articles" aria-labelledby="nw-articles-title">
                <div className="km-container">
                    <div className="nw-sectionHead" data-reveal>
                        <div>
                            <h2 className="km-title" id="nw-articles-title">Articles and news</h2>
                            <p className="km-lead">The latest from Kole Medical, newest first.</p>
                        </div>
                    </div>
                    {SHOW_UNPUBLISHED && posts.some(post => post.status !== "published") && (
                        <p className="nw-preview-note" role="note">
                            Development preview: drafts and scheduled articles are shown here, labelled. The live site only shows published articles.
                        </p>
                    )}
                    <div className="km-cardRow nw-grid">
                        {comingSoon && <NewsComingSoon eventsLink={{ hash: "#events" }} />}
                        {posts.map((post, index) => <NewsCard key={post.slug} post={post} revealOrder={index + (comingSoon ? 1 : 0)} headingLevel={3} />)}
                    </div>
                </div>
            </section>

            {/* ── UPCOMING EVENTS ── */}
            <UpcomingEvents />

            <Footer />
            <WhatsAppChat />
        </div>
    );
};

export default News;
